<template>
    <div class="password-reset system-notice-detail">
         <ul class="sub-navigation">
            <li @click="backToSystem"> <i class="iconfont icon-chexiao"></i> 公告详情</li>
        </ul>

        <div class="panel">
           <div class="notice-inline">
                <div class="system-notice-detail-title">
                    <p class="notice-title">{{detail.noticeTitle}}</p>
                    <p class="sub-title">
                        <span><i class="iconfont icon-caijishijian"></i> 发布时间 ：{{detail.createTime}}</span>
                        <span><i class="iconfont icon-user"></i> 发布人: {{detail.createUser}}</span>
                    </p>
                </div>

                <div class="pre-detail" v-html="detail.noticeContent">

                </div>
           </div>
        </div>
    </div>
</template>

<script>
    import mixins from '../mixins'
    export default {
        mixins: [mixins],
        data(){
            return {
                detail: {

                }
            }
        },
        mounted(){
            this.getDetail();
        },
        methods: {
            backToSystem(){
                this.$parent.showOutsideComponent('base-systemnotice')
                this.$store.commit('systemData', {
                    componentName: 'base-systemnotice'
                })
            },
            getDetail(){
              //TODO:
              //this.$store.commit('updateOutComponentLoading', true)
                let noticeId = this.$store.state.docStore.systemData.id
                this.$http.post('api/notice/noticeId', {
                    noticeId
                    }).then( res => {
                    this.$store.commit('updateOutComponentLoading', false)
                   this.detail = res;
                }).catch( error => {
                    this.$message({type: 'error', message: error.msg})
                    this.$store.commit('updateOutComponentLoading', true)
                })
            }
        }
    }
</script >
<style scoped lang="scss">
    .system-notice-detail{
        height: calc(100% - 55px);
    }
    .system-notice-detail .sub-navigation{
        width: 16.7%;
    }
    .system-notice-detail .panel{
        margin-left: 16.7%;
    }
</style>





// WEBPACK FOOTER //
// src/component/base-systemnoticedetail.vue